/**
 * @description: 优惠券管理
 * @author: Jsj
 * @Compile：2021-03-23 14：00
 * @update: Jsj(2021-03-23 18：00)
 * @memo：  couponBag  优惠券礼包  couponManage  优惠券    couponRecord    优惠券核销
 */

export default [
  {
    path: "/couponBag",
    component: () => import("../pages/coupon/couponBag/couponBag.vue"),
    name: "couponBag",
    title: "优惠券礼包",
    meta: {
      title: "优惠券礼包"
    }
  },
  {
    path: "/couponManage",
    component: () => import("../pages/coupon/couponManage/couponManage.vue"),
    name: "couponManage",
    title: "优惠券",
    meta: {
      title: "优惠券"
    }
  },
  {
    path: "/couponReceive",
    component: () => import("../pages/coupon/couponReceive/index.vue"),
    name: "couponReceive",
    title: "领券中心",
    meta: {
      title: "领券中心"
    }
  },
  {
    path: "/couponRecord",
    component: () => import("../pages/coupon/couponRecord/couponRecord.vue"),
    name: "couponRecord",
    title: "优惠券核销",
    meta: {
      title: "优惠券核销"
    }
  }
];
